export const UNION_MANAGER_BASE = '/app/manager'

/** Absolute URLs of the Union manager sections, keyed by top-nav view (SIB-706). */
export const UNION_MANAGER_ROUTES = {
  orders: `${UNION_MANAGER_BASE}/orders`,
  capacityManagement: `${UNION_MANAGER_BASE}/capacity`,
  marketplace: `${UNION_MANAGER_BASE}/marketplace`,
  serviceBilling: `${UNION_MANAGER_BASE}/service-billing`,
  export: `${UNION_MANAGER_BASE}/export`,
  settings: `${UNION_MANAGER_BASE}/banks`,
} as const

export type UnionManagerView = keyof typeof UNION_MANAGER_ROUTES

/** Resolves the active manager section from a pathname, including nested detail pages. */
export function getUnionManagerView(pathname: string): UnionManagerView | null {
  const entries = Object.entries(UNION_MANAGER_ROUTES) as [UnionManagerView, string][]
  const match = entries.find(([, path]) => pathname === path || pathname.startsWith(`${path}/`))
  return match?.[0] ?? null
}
